import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '../../../../core/services/ApiService';
import { Observable, of, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ISessionStatistics } from '../interfaces/ISessionStatistics';
import { StatisticsStore } from '../stores/StatisticsStore';
import { ShowsStore } from '../../../shows/core/stores/ShowsStore';
import { IShowStatistics } from '../interfaces/IShowStatistics';
import { WebCashPermissionKeys } from '../../../../core/enums/WebCashPermissionKeys';
import { PermissionService } from '../../../auth/core/services/PermissionService';
import { nonBlocking } from '../../../../core/http/non-blocking.context';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {

  private readonly _basePath = '/statistics';
  private readonly _apiService = inject(ApiService);
  private readonly _statisticsStore = inject(StatisticsStore);
  private readonly _showsStore = inject(ShowsStore);
  private readonly _permissionService = inject(PermissionService);

  public getSessionStatistics(): Observable<IResponse<ISessionStatistics>> {
    if (!this._permissionService.hasPermission(WebCashPermissionKeys.WebCxCashSessionStatistics)) {
      this._statisticsStore.sessionStatistics.set(null);

      return of({ data: null } as IResponse<ISessionStatistics>);
    }

    return this._apiService.get(`${this._basePath}/session`, new HttpParams(), nonBlocking())
      .pipe(
        tap(res => this._statisticsStore.sessionStatistics.set(res?.data ?? null))
      );
  }

  public getShowsStatistics(): Observable<IResponse<IShowStatistics[]>> {
    return this._apiService.post(
      `${this._basePath}/shows`,
      { ids: this._showsStore.shows().map(show => show.id) }
    )
      .pipe(
        tap(res => this._statisticsStore.showsStatistics.set(res.data))
      );
  }
}
